import TumengAttrRow from './src/index.vue'

TumengAttrRow.install = function(Vue) {
  Vue.component(TumengAttrRow.name, TumengAttrRow)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengAttrRow)
}

export default TumengAttrRow
